import { put, take, call, select } from 'redux-saga/effects';

import { getErrorDataString } from '@epi-helpers/ErrorDataHelper';
import { HandleUnauthorizedError } from '@epi-helpers/AuthorizeHelper';
import { getLoginState } from '@epi-selectors/login';
import { routerPaths } from '@epi-constants/routerPaths';
import {
  UnauthorizedErrorName,
  ForbiddenErrorName,
  ApiErrorName
} from '@epi-constants/errorName';
import { OverlaysConstants, ApiConstants } from '@epi-constants/actions';

import { overlaysActions } from './overlays.slice';

export function* showErrorMessageOnConfirmationPasswordPopup(message = '') {
  yield put(overlaysActions.setPasswordPopupError(message));
}

export function* hideErrorMessageOnConfirmationPasswordPopup() {
  yield put(overlaysActions.clearPasswordPopupError());
}

export function* setLoadingPasswordPopup(isLoading = false) {
  yield put(overlaysActions.setPasswordPopupLoading(isLoading));
}

function* setPopupVisibility(show, message = '') {
  yield put(overlaysActions.setPasswordPopupVisibility({ show, message }));
}

function* forgotPassword() {
  yield put({
    type: `${ApiConstants.LOGOUT_ACTION}_REQUEST`,
    gotoUrl: routerPaths.resetPassword
  });
}

export function* askConfirmationPassword(message = '') {
  yield call(setPopupVisibility, true, message);

  const buttonActionResult = yield take(
    `${OverlaysConstants.PASSWORD_POPUP_ACTION}`
  );

  switch (buttonActionResult.actionType) {
    case 'cancel':
      yield call(setPopupVisibility, false);
      yield call(showErrorMessageOnConfirmationPasswordPopup);
      return null;
    case 'forgot_password':
      yield call(forgotPassword);
      yield call(setPopupVisibility, false);
      return null;
    default:
      return yield buttonActionResult.password;
  }
}

export function* hideConfirmationPasswordPopup() {
  yield call(setPopupVisibility, false);
}

export function* handleErrors(error) {
  const message =
    error.name === ApiErrorName && error.content
      ? getErrorDataString(error)
      : error.message;

  if (error.name === ForbiddenErrorName || error.name === ApiErrorName) {
    yield call(showErrorMessageOnConfirmationPasswordPopup, message);
  }
  if (error.name === UnauthorizedErrorName) {
    const login = yield select(getLoginState);
    yield call(HandleUnauthorizedError, login);
    return true;
  }
  return false;
}

export function* callWithPassword(fn, params = {}, message = '') {
  while (true) {
    const password = yield call(askConfirmationPassword, message);
    if (!password) {
      yield call(hideConfirmationPasswordPopup);
      yield call(hideErrorMessageOnConfirmationPasswordPopup);
      return false;
    }
    yield call(setLoadingPasswordPopup, true);

    let isSuccess = false;
    let closePopup = false;
    try {
      yield call(fn, { ...params, password });
      isSuccess = true;
    } catch (error) {
      closePopup = yield call(handleErrors, error);
    }

    yield call(setLoadingPasswordPopup, false);
    if (isSuccess || closePopup) {
      yield call(hideConfirmationPasswordPopup);
      yield call(hideErrorMessageOnConfirmationPasswordPopup);
      return isSuccess;
    }
  }
}
